export const CHANGE_SCREEN_TYPE = 'CHANGE_SCREEN_TYPE'
